<template>
  <div>
    <div class="container">
      <div class="mt-3">
        <b-card no-body>
          <b-tabs
            pills
            card
            lazy
          >
          <!--
          <b-tab title="Create">
              <qrcode-create></qrcode-create>
            </b-tab>
            -->
            <b-tab title="Search">
              <qrcode-checkin></qrcode-checkin>
            </b-tab>
            <b-tab title="Report">
              <qrcode-list></qrcode-list>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
    <!-- ./container -->
  </div>
</template>
<script>
//import QrcodeCreate from "./QrcodeCreate.vue";
import QrcodeList from "./QrcodeList.vue";
import QrcodeCheckin from "./QrcodeCheckin.vue";

//import Test from "./Test.vue";
export default {
  components: {
    //QrcodeCreate,
    QrcodeCheckin,
    QrcodeList,
    //Test
  },
  data() {
    return {
      memberid: this.$route.params.id,
      loading: false,
      member: null,
    };
  },
  mounted() {

  },
  methods: {

  }
};
</script>
